export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',

  // Gestion
  USERS: '/users',
  USER_DETAIL: '/users/:uuid',
  ORGANISATIONS: '/organisations',
  ORGANISATION_DETAIL: '/organisations/:uuid',
  DOMAINS: '/domains',
  DOMAIN_DETAIL: '/domains/:uuid',

  // Operations
  AUTOMATIONS: '/automations',
  AUTOMATION_EXECUTION: '/automations/executions/:uuid',
  AUTOMATION_QUEUES: '/automations/queues',
  VAULTS: '/vaults',
  VAULT_DETAIL: '/vaults/:uuid',

  // Finances
  BILLING: '/billing',
  INVOICES: '/billing/invoices',
  PRICING: '/billing/pricing',
  REVENUE: '/billing/revenue',

  // Communication
  COMMUNICATIONS: '/communications',
  INCIDENTS: '/communications/incidents',
  MAINTENANCE: '/communications/maintenance',
  ANNOUNCEMENTS: '/communications/announcements',
  EMAIL_CAMPAIGNS: '/communications/emails',
  SUPPORT: '/support',
  SUPPORT_DETAIL: '/support/:uuid',

  // Technique
  MONITORING: '/monitoring',
  LOGS: '/monitoring/logs',
  BROWSER_POOL: '/monitoring/browser-pool',

  // Configuration
  SETTINGS: '/settings',
  AUDIT_LOG: '/settings/audit-log',
  PROFILE: '/profile',
} as const;
